module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction ")])]), _c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', [_vm._v("“That which is not good is not delicious to a well-governed and wise appetite.” ")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—John Milton, 1608–1674, Comus ")])]), _vm._v(" "), _c('p', [_vm._v("As celebrated poet John Milton so correctly points out, “That which is not good is not\n        delicious.” As a long-time restaurant critic, frequently subjected to eating bad food (as\n        well as a whole lot of delicious food), and a dedicated chef, instructor, and eight-time\n        cookbook author, I will add my personal motto to his thoughts: Life is too short to eat bad\n        food, mashed or otherwise. ")]), _vm._v(" "), _c('p', [_vm._v("Indeed, mashed foods conjure up images of comfort, even childhood. During the process of\n        writing this book, I kept envisioning a young child barely bellied up to a table in a chair\n        that’s too big and low, cradling an oversize spoon, eagerly digging into some mashed\n        deliciousness, legs dangling, toes tapping in anticipation, butter dripping down his chin.\n        Maybe it was a subliminal me? There is probably a little bit of that kid in all of us, which\n        is a big reason why writing this book was so much fun for me, and hopefully will be equally\n        fun for you to read and cook from. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of vegetables."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of vegetables.",
      "src": "images/Outtake_5--Edit-965.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("In addition to comfort, mashed foods inspire the notion of simplicity, which is largely\n        true. But, as I’ve learned going through life, particularly in cooking, making “simple” food\n        delicious presents an extra challenge. What makes average mashed potatoes stand out from\n        unforgettable, delicious ones, the kind you dream about? What makes a fruit compote sing, or\n        a winter root vegetable mash make you want to sing? ")]), _vm._v(" "), _c('p', [_vm._v("As you work your way through this book, you’ll see that the answers boil down to a few\n        simple concepts that require dedication to reach ethereal, delicious mashed food levels. The\n        most important thing is to start out with the freshest, best-quality food and ingredients\n        you can find. You can’t make delicious from tired or processed. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of cooked potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of cooked potatoes.",
      "src": "images/Outtake_3-7017-Edit-977.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Second, consider the texture of the principal ingredient. Not unlike matching the right\n        accessory with a dress, or the right place to hang a painting on the wall, you want to think\n        about what might complement it. Barley in mashed potatoes? Probably not, but cauliflower?\n        Absolutely, yes. ")]), _vm._v(" "), _c('p', [_vm._v("Layering flavors is also essential. The recipes throughout this book are designed to build\n        upon inherent flavors in any given food and layer them back into the dish. For example,\n        going back to cauliflower, the water or stock in which it is simmered is later brought back\n        into the dish, avoiding waste (and throwing away nutrition) and doubling up on flavor. Many\n        fruits and vegetables are roasted and then mashed, which is another way of doing the very\n        same thing. Stocks, broths, wines, and other flavoring ingredients are reduced or steeped\n        and then delicately returned to whence they came. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of herbs."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of herbs.",
      "src": "images/Outtake_4-2-973P.jpg"
    }
  })])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e67",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Finally, choosing the right method to mash (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e1842"
    }
  }, [_vm._v("Basic\n          Mashing Tools")]), _vm._v(") is mandatory. It’s like matching the right color makeup to your skin\n        tone. The wrong one will make you look ill, while the right one is barely perceptible,\n        perfectly beautiful and natural. For example, mashing potatoes with a food processor is\n        equivalent to turning them to glue, while a food mill or old-fashioned manual masher will\n        render the potatoes into fluffy spud pillows, eagerly awaiting the butter and cream they’ll\n        readily absorb to make them sublime. ")]), _vm._v(" "), _c('p', [_vm._v("Throughout the pages I strive to clearly define and make understandable some of these\n        rules, but remember with rules, there are always exceptions. It is my hope you’ll use the\n        methods, inspirations, and concepts to create some memorable, always delicious, mashed\n        treats using your palate and finesse as a personal guide. ")]), _vm._v(" "), _c('p', [_vm._v("As always, bon appétit! ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("HOLLY")])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of blueberries."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of blueberries.",
      "src": "images/Blues-Busting_Blueberry_Ice_Cream--989.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b208a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0